// import axios from 'axios';
import { getPlants } from '../../../services/scheduling/plant';

export default {
    namespaced: true,
    actions: {
        fetch: (context) => {
            context.commit('SET_LOADING', true)
            getPlants()
            .then((response) => {
                context.commit('SET_PLANTS', response.data);
                context.commit('SET_LOADING', false);
            })
            .catch((error) => {
                context.commit('SET_LOADING', false);
                if(error.response && error.response.status == 401) context.dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
            })
        }
    },
    state: {
        plants: [],
        loading: false,
    },
    getters: {
        plants: (state) => {
            return state.plants;
        },
        loading: (state) => {
            return state.loading;
        }
    },
    mutations: {
        SET_PLANTS: (state, plants) => {
            state.plants = plants;
        },
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        }
    }
}